import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { AuthRepository, UserRole } from '../auth.repository';

const TRANSLATOR_PATHS = ['/home', '/translate', '/firststart', '/user-settings', '/support', '/sign-out'];

@Injectable({ providedIn: 'root' })
export class TranslatorAccessGuard implements CanActivate, CanActivateChild {
  constructor(private authRepository: AuthRepository, private router: Router) {}

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.allow(state.url);
  }

  canActivateChild(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.allow(state.url);
  }

  private allow(url: string): boolean {
    const user = this.authRepository.getUser();
    if (!user || user.role !== UserRole.Translator) {
      return true;
    }
    const path = url.split('?')[0];
    const allowed = TRANSLATOR_PATHS.some((item) => path === item || path.startsWith(item + '/'));
    if (!allowed) {
      this.router.navigate(['/home']);
      return false;
    }
    return true;
  }
}
